import React from 'react';
import s from './style.module.css';
import { URL } from '@Pages/url';
import PhoneSVGIcon from '@Components/svg_icon/phone';
import OperatorSVGIcon from '@Components/svg_icon/operator';
import LineInquiry from '@Components/line_inquiry/view';

const FooterInquiry = () => {
    return (
        <div className={s.inquiry}>
            <div className={s.mask} />
            <p className={s.inquiry_title}>
                <OperatorSVGIcon front_fill='#E1742D' />
                お問合せはこちら
            </p>
            <div className={s.inquiry_left}>
                <p className={s.inquiry_text}>電話でお問合せ</p>
                <a href='tel:0120-18-0072'>
                    <PhoneSVGIcon />
                    0120-18-0072
                </a>
            </div>
            <div className={s.border} />
            <div className={s.inquiry_right}>
                <a className={s.inquiry_button} href={URL.CONTACT}>
                    WEBでお問合せ
                </a>
            </div>
            <div className={s.line_inquiry}>
                <LineInquiry />
            </div>
        </div>
    );
};

export default FooterInquiry;
